import React from "react";
import Fancybox from "../../../main-page-blocks/fancybox";
import "../media-gallery.less";

export default function PlatformNewsMediaGallery({items, galleryName}) {
    if (!items || items.length === 0) {
        return null;
    }

    return (
        <Fancybox>
            <div className="platform-news-media-gallery">
                {items.map((item) => (
                    <a
                        className="platform-news-media-gallery__item"
                        data-fancybox={galleryName}
                        data-caption={item.alt}
                        href={item.src}
                        key={item.src}
                    >
                        <img
                            src={item.thumbnail || item.src}
                            alt={item.alt}
                            loading="lazy"
                            decoding="async"
                        />
                    </a>
                ))}
            </div>
        </Fancybox>
    );
}
